import { Component, HostListener, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { GallaryService, GalleryPagination, GalleryVM, InputParameters } from './gallary.service';
import { ActivatedRoute, Router } from '@angular/router';
import { InitScripts } from '../app.constants';
import { MetamanagerService } from '../metamanager.service';


@Component({
  selector: 'app-gallary',
  templateUrl: './gallary.component.html',
  styleUrls: ['./gallary.component.css']
})
export class GallaryComponent implements OnInit {
  title: any;
  gallery = new Observable<GalleryVM[]>();
  gallery_col1 = new BehaviorSubject<GalleryVM[]>([]);
  gallery_col2 = new BehaviorSubject<GalleryVM[]>([]);
  gallery_col3 = new BehaviorSubject<GalleryVM[]>([]);
  gallery_col4 = new BehaviorSubject<GalleryVM[]>([]);

  input = new InputParameters();
  galleryLocal = new BehaviorSubject<GalleryVM[]>([]);
  nextDataAvailable = new BehaviorSubject<boolean>(false);
  inProgress = new BehaviorSubject<boolean>(false);

  constructor(private galleryService: GallaryService, private router: Router, private route: ActivatedRoute,
    private metaManager: MetamanagerService) {
    new InitScripts().loadScripts();
   }

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  ngOnInit(): void {
    this.metaManager.updateMetaTitle("Mahanubhav Image Gallery | Gangatir | Sthan Images | sarvadhnya.com",
      "Mahanubhav Panth sthan images, sthan details, sthan location, sthan leela, Chakradhar Swami sthan, Govind Prabhu sthan, Chakrapani sthan, Dattatrey Prabhu Sthan etc",
      "Mahanubhav sthan, Mahanubhav gangatir, Mahanubhav images, Chakradhar swami sthan, Mahanubhav image gallery");
    //this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.gallery = this.galleryLocal;
    this.title = "Images"
    this.get();
    
  }

  @HostListener("window:scroll", [])
  onScroll(): void {
    document.visibilityState
    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
      if (!this.inProgress.getValue() && this.nextDataAvailable.getValue()) {
        console.log(this.input.pageNumber);
        this.input.pageNumber += 1;
        this.get();
      }
    }
  }

  get() {
    this.inProgress.next(true);
    var v = this.galleryService.get(this.input).pipe(
      map((root: GalleryPagination) => {
        this.nextDataAvailable.next(root.remainingCount > 0);
        return root.content
      })
    ).subscribe(result => {
      result.forEach((image, i) => {
        if (i == 0 || i == 4 || i == 8) {
          var v = this.gallery_col1.getValue().concat(image);
          this.gallery_col1.next(v);
        }
        if (i == 1 || i == 5 || i == 9) {
          var v = this.gallery_col2.getValue().concat(image);
          this.gallery_col2.next(v);
        }
        if (i == 2 || i == 6 || i == 10) {
          var v = this.gallery_col3.getValue().concat(image);
          this.gallery_col3.next(v);
        }
        if (i == 3 || i == 7 || i == 11) {
          var v = this.gallery_col4.getValue().concat(image);
          this.gallery_col4.next(v);
        }

      })
      var v = this.galleryLocal.getValue().concat(result);
      this.galleryLocal.next(v);
      this.inProgress.next(false);
    });
  }

  SearchText($event: string) {
    this.input.search = $event;
    this.galleryLocal.next([]);
    this.get();
  }

  
}


